export { default } from './DataDisplay';
export { DataDisplayVariant } from './DataDisplay.constants';
export { useResponsiveDataDisplayVariant } from './hooks/useResponsiveDataDisplayVariant';
